<template>
  <span>
    <v-footer v-bind="localAttrs" :padless="padless">
      <v-card flat tile width="100%" class="text-center">
        <v-card-text>
          <v-btn
            v-for="icon in items"
            :key="icon.id"
            class="mx-3"
            icon
            @click="openLink(icon.link)"
          >
            <v-icon size="28px">{{ icon.icon }}</v-icon>
          </v-btn>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="grey--text">
          &copy; 2020
          <strong>
            <!-- <a href="https://www.budrewicz-mateusz.com">Mateusz Budrewicz</a> -->
          </strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </span>
</template>

<script>
export default {
  name: "Footer",

  data: () => ({
    items: [
      // {
      //   icon: "mdi-calendar",
      //   link: "https://www.moment.pl/olio?employee_id=88945#",
      // },
      {
        icon: "mdi-email",
        link: "mailto:olreh.opole@gmail.com"
      },
      {
        icon: "mdi-phone",
        link: "tel:+48 730 230 674"
      },
      {
        icon: "mdi-facebook",
        link: "https://www.facebook.com/fizjo.aleksandraskomudek"
      }
    ],
    icons: ["mdi-calendar", "mdi-facebook", "mdi-email", "mdi-phone"],
    padless: false,
    variant: "default"
  }),
  computed: {
    localAttrs() {
      const attrs = {};

      if (this.variant === "default") {
        attrs.absolute = false;
        attrs.fixed = false;
      } else {
        attrs[this.variant] = true;
      }
      return attrs;
    }
  },
  methods: {
    openLink(link) {
      if (
        link === "https://www.moment.pl/olio?employee_id=88945#" ||
        link === "https://www.facebook.com/"
      )
        window.open(link, "_blank");
      else {
        window.open(link, "_top");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.iconsLeft {
  padding-top: 25px;
}
.v-footer,
.v-card {
  background-color: $backgroundDarkness !important;
  color: rgba(0, 0, 0, 0.87);
  padding: 0px 0px !important;
}
.v-divider {
  display: flex !important;
  max-width: 60% !important;
  border: solid;
  border-width: thin 0 0 0;
  transition: inherit;

  align-content: center !important ;
  margin: auto !important;
}
hr {
  margin-top: 0rem !important ;
  margin-bottom: 0rem !important;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
